import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, Stack, Typography } from "@mui/material";
import CustomModal from "components/atoms/CustomModal";
import { downloadOnClick } from "utils/exportToExcel";
import ResultDetails from "components/molecules/patient/singlePatient/investigationsSubComponent/ResultDetails";

const Row = ({ row, toggleModal }) => {
  const handleExport = (results = []) => {
    if (!results.length) return;

    results.forEach((result, idx) =>
      downloadOnClick(result, `result_${idx + 1}_${new Date().getTime()}`)
    );
  };

  return (
    <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell component="th" scope="row" align="left">
        {row.test.testType}
      </TableCell>
      <TableCell align="left">{row.test.testName}</TableCell>
      <TableCell align="left">{row.doctor.fullName}</TableCell>

      <TableCell align="left">
        <Button
          variant="text"
          color="secondary"
          sx={{ fontSize: "12px" }}
          onClick={() => toggleModal(row)}
          disabled={!row?.result}
        >
          View Result
        </Button>
      </TableCell>
      <TableCell align="left">
        <Button
          variant="text"
          color="secondary"
          sx={{ fontSize: "12px" }}
          onClick={() => handleExport(row.resultUrls)}
          disabled={!row?.resultUrls.length}
        >
          Download file(s)
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default function RadiologyTable({ data, fromSummary = false }) {
  const modalRef = React.useRef(null);
  const [result, setresult] = React.useState({});

  const toggleModal = (item) => {
    setresult(item);
    modalRef?.current?.handleToggle();
  };
  const isEmpty = () => {
    return data.every((d) => !d?.["radiology"] || !d?.["radiology"]?.length);
  };

  const formattedData = data.filter(
    (d) => d?.["radiology"] && d?.["radiology"]?.length
  );
  return (
    <>
      {isEmpty() ? (
        <Paper sx={{ p: 2 }}>
          <Typography>No data</Typography>
        </Paper>
      ) : (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: !fromSummary ? "background.light" : "",
                }}
              >
                <TableCell sx={{ fontWeight: "bold" }} align="left">
                  Test Type
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }} align="left">
                  Test Name
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }} align="left">
                  Doctor
                </TableCell>

                <TableCell sx={{ fontWeight: "bold" }} align="left">
                  Result
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }} align="left">
                  Other files
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {formattedData?.map((d) =>
                d?.radiology?.map((row) => (
                  <Row key={row._id} row={row} toggleModal={toggleModal} />
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <CustomModal
        ref={modalRef}
        backdropSx={{
          marginTop: "0px !important",
        }}
        childrenContSx={{
          p: 2,
          width: {
            xs: "90%",
            sm: "60vw",
          },
        }}
      >
        <ResultDetails data={result} from={"radiology"} />
      </CustomModal>
    </>
  );
}
